export default __webpack_public_path__ + "static/media/Mail.1b3c4524.svg";